import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { getAddModuleSidebarLoaded, getIframeRendered } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getIsCustomEmail } from 'EmailEditorUI/redux/selectors/emailCategoriesSelectors';
import { getTemplateContainsFlexArea } from 'EmailEditorUI/redux/selectors/templateInfoSelectors';
import { getIsAutomateRouteAndIsUngatedForOneRouteUI, getIsNotContentRouteAndIsUngatedForOneRouteUI } from 'EmailEditorUI/redux/selectors/AppStateSelectors';
export const getIsLayoutBuilderReady = basicSelector(state => {
  const iframeRendered = getIframeRendered(state);
  const isCustomEmail = getIsCustomEmail(state);
  const templateContainsFlexArea = getTemplateContainsFlexArea(state);
  const isNotContentRouteAndIsUngatedForOneRouteUI = getIsNotContentRouteAndIsUngatedForOneRouteUI(state);
  const isAutomateRouteAndIsUngatedForOneRouteUI = getIsAutomateRouteAndIsUngatedForOneRouteUI(state);
  if (isAutomateRouteAndIsUngatedForOneRouteUI) {
    return true;
  }
  if (isCustomEmail && !templateContainsFlexArea || isNotContentRouteAndIsUngatedForOneRouteUI) {
    return iframeRendered;
  }
  return getAddModuleSidebarLoaded(state);
});
export const getIsTrellisTheme = basicSelector(state => state.appStatus.isTrellisTheme);